exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".user-avatar {\n  -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.15);\n          box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.15); }\n\n@-moz-document url-prefix() {\n  .user-avatar > text:nth-child(2) {\n    transform: translate(0, 3px); } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./src/style/components/user/user-avatar.scss
// module id = 1197
// module chunks = 49